import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { LazyLoadImageModule, scrollPreset } from 'ng-lazyload-image';

//import { routing } from './app-routing.module';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { DetailsComponent } from './details.component';
import { DetailsV2Component } from './detailsv2.component';
import { LightboxModule } from 'ngx-lightbox';
import { TooltipModule } from 'ng2-tooltip-directive';
//import { Safe } from '../pipes/safe.pipe';
import { CoreModule } from '../core/core.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    DetailsComponent,
    DetailsV2Component,
    //Safe,
  ],
  imports: [

    //routing,
    AppRoutingModule,
    HttpClientModule,
    BrowserModule,
    HttpModule,
    LazyLoadImageModule.forRoot({
      preset: scrollPreset // <-- tell LazyLoadImage that you want to use scrollPreset
    }),
    LightboxModule,
    TooltipModule,
    FormsModule,
    CoreModule
  ],
  exports: [
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
